import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "./twb.css";

const Dominious = (props) => {
  const { className } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const closeBtn = (
    <button className='close' onClick={toggle}>
      &times;
    </button>
  );

  return (
    <div>
      <button className='button' onClick={toggle}>
        See the project
      </button>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle} close={closeBtn}>
          Modal title
        </ModalHeader>
        <ModalBody className='modalBody'>
          <img
            src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614135741/FireShot_Pro_Webpage_Screenshot_012_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_zjyod9.png'
            alt='img'
          />
          <h2>Dominious Restaurant</h2>
          <div className='tag-body-single'>
            <div className='tags'>Ruby on Rails</div>
            <div className='tags'>Javascript</div>
            <div className='tags'>PostgreSQl</div>
          </div>
          <p>
            This is a Full Stack meat restaurant website built with Ruby on
            Rails, Javascript, PostgreSQL and bootstrap where people can order
            for the type of meat they are interested in. There are four(4)
            categories of meat: cow beef, goat, chicken and turkey.
          </p>
          <div className='tag-body-live'>
            <div className='tag one'>
              <a
                href='https://my-restaurant-store.herokuapp.com/'
                target='_blank'
              >
                See live
              </a>
            </div>
            <div className='tag two'>
              <a
                href='https://github.com/Elijahscriptdev/online-store'
                target='_blank'
              >
                see code
              </a>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Dominious;
